import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { DeletePhotoItemParams } from '@/shared/api/requests/photo/delete-photo-item/request';
import { deletePhotoItem } from '@/shared/api/requests/photo/delete-photo-item/request';

export const useDeletePhotoItemMutation = (
  settings?: MutationSettings<DeletePhotoItemParams, typeof deletePhotoItem>
) =>
  useMutation({
    mutationKey: ['DeletePhotoItem'],
    mutationFn: ({ params, config }) =>
      deletePhotoItem({
        params,
        config
      }),
    ...settings?.options
  });
